<template>
  <v-toolbar-title :class="$store.state.account.current ? 'pl-1' : 'pl-10'">{{
    $t("site-name")
  }}</v-toolbar-title>
</template>

<script>
export default {
  name: "Logo"
};
</script>
